import { Outlet } from 'react-router-dom';
import TopNav from './TopNav';
import Sidebar from './Sidebar';
import AuthCheck from '../AuthCheck';
import { WebsiteProvider } from '../../contexts/WebsiteContext';

export default function Layout() {
  return (
    <AuthCheck>
      <WebsiteProvider>
        <div className="min-h-screen bg-background">
          <TopNav />
          <div className="flex">
            <Sidebar />
            <main className="flex-1 overflow-y-auto">
              <Outlet />
            </main>
          </div>
        </div>
      </WebsiteProvider>
    </AuthCheck>
  );
}
